import { ReceptionEditKinds } from "../kinds";
import { Reception, ReceptionDetail } from "../reception";
import { ReceptionEditorDispInfo } from "./ReceptionEditorDispInfo";
import { FormatReference } from "../../format";

// 依頼作成・編集用model
export class ReceptionEditor {
  public mode: ReceptionEditKinds = ReceptionEditKinds.Create;
  public reception: Reception = new Reception();
  public commonReceptionDetail: ReceptionDetail = new ReceptionDetail();
  public receptionDetails: ReceptionDetail[] = [new ReceptionDetail()];

  public requestSheetFormats: FormatReference[] = [];
  public displayInfo: ReceptionEditorDispInfo = new ReceptionEditorDispInfo();

  // 受付コピー作成の場合、引用元の受付IDをセット
  public sourceReceptionId: number;
  // 依頼コピー作成の場合、引用元の依頼詳細IDをセット
  public sourceReceptionDetailId: number;

  // データ取得時点の最後のWF履歴（排他チェック用）
  public lastWorkflowHistoryId: string;

  clone(): ReceptionEditor {
    const newObj = new ReceptionEditor();
    newObj.mode = this.mode;
    newObj.reception = this.reception.clone();
    newObj.commonReceptionDetail = this.commonReceptionDetail.clone();
    newObj.receptionDetails = this.receptionDetails.concat();

    // 更新通知で吹き飛ぶのでちゃんとクローンしておく
    newObj.displayInfo = this.displayInfo;
    newObj.requestSheetFormats = this.requestSheetFormats.concat();
    newObj.sourceReceptionId = this.sourceReceptionId;
    newObj.sourceReceptionDetailId = this.sourceReceptionDetailId;

    return newObj;
  }
}
